<template>
  <Content  @back="$router.push('/home')">
    <template v-slot:nav_left>
      球队列表
    </template>
    <!-- <template v-slot:nav_right>
    </template> -->
    <template v-slot:content_right>
      <div class="select_wrap">
        <div class="select_box">
           <!-- <select v-model="selectVal.organUuid" class="yioks_select" @change="changeSelectOrg" >
            <option value=''>全部区体育行政部门</option>
            <option
              v-for="item in selectOrganList"
              :key="item.value"
              :value="item.value"
            >{{ item.label }}</option>
          </select> -->
          <select v-model="selectVal.youthUuid" class="yioks_select" @change="changeQuery(true)" >
            <option value=''>全部培训机构</option>
            <option
              v-for="item in selectCenterList"
              :key="item.value"
              :value="item.value"
            >{{ item.label }}</option>
          </select>

          <select
              v-model="selectVal.squadDissolve"
              class="yioks_select"
              @change="changeQuery(true)"
          >
            <option value="">球队状态</option>
            <option value="0">正常</option>
            <option value="1">已停止</option>
          </select>
        </div>
        <div class="search_box">
          <input
              v-model.trim="selectVal.keyWord"
              type="text"
              class="yioks_input"
              placeholder="请输入关键词"
              @keyup.enter="changeQuery(true)"
            >
            <div class="yioks_btn" @click="changeQuery(true)">搜索</div>
        </div>
      </div>
      <div class="list_wrap">
        <div class="table">
          <div class="thead">
            <div class="tr">
              <div class="th seq"><strong>序号</strong></div>
              <div class="th squadName"><strong>球队简称</strong></div>
              <div class="th organName"><strong>管理单位</strong></div>
              <div class="th centerName"><strong>单位</strong></div>
              <div class="th coachName"><strong>主教练</strong></div>
              <!--<div class="th leaderName"><strong>球队性质</strong></div>-->
              <div class="th opt"><strong>操作</strong></div>
            </div>
          </div>
          <div class="scrollArea">
            <vue-scroll>
              <div class="tbody">
                 <div
                    v-for="(item, index) in squadList"
                    :key="index"
                    class="tr">
                    <div class="td seq">
                      <p>{{ index + 1 }}</p>
                    </div>
                    <div class="td squadName">
                      <p :class="{ squadDissolve: item.squadDissolve }">{{ item.shortName || '--' }}</p>
                    </div>
                    <div class="td organName">
                      <p>{{ item.organShortName || '--' }}</p>
                    </div>
                    <div class="td centerName" :title="item.youthShortName">
                      <p>{{ item.youthShortName || '--' }}</p>
                    </div>
                    <div class="td coachName">
                      <p>{{item.chiefCoachName || '--'}}</p>
                    </div>
                    <div class="td opt">
                      <p>
                        <span class="item" @click="goDetail(item)">查看</span>
                      </p>
                    </div>
                  </div>
              </div>
            </vue-scroll>
          </div>
        </div>

      </div>
    </template>
  </Content>
</template>

<script>
import coach from '@/api/coach'
import squad from '@/api/squad'
import storage from '@/utils/storage'

  export default {
    name: 'SquadList',

    components: {
      'Content': () => import('@/components/layout/list'),
    },

    filters: {
      filterSex (val) {
        switch (val) {
          case 'male': return '男足'
          case 'female': return '女足'
          case 'mixed': return '男女混合'
          default: return '--'
        }
      }
    },

    data() {
      return {
        selectVal: {
          keyWord: '',
          youthUuid: '',
          organUuid: '',
          squadDissolve: ''
        },
        selectOrganList: [],
        selectCenterList: [],
        userRole: storage.get('userInfo').userRole,
        uuid: storage.get('userInfo').uuid,
        squadList: [],
      }
    },

    async created() {
      this.loadSearchSelectList();
    },

    mounted() {

      this.loadSquadList();
    },

    methods: {

      loadSquadList() {
        const _ = require('lodash');
        const { keyWord, youthUuid, organUuid, squadDissolve } = this.selectVal;

        const paramsData = {
          page: 0,
          size: 50,
          key: keyWord,
          youthUuid,
          organUuid,
          squadDissolve,
        };
        squad.getSquadListCoach(paramsData).then(res => {
          if(res.code) {
            this.$message.error(res.msg);
            return
          }
          this.squadList = res.content;
        }).catch(err => {
          console.error('err', err)
        })
      },

      // 设置球队列表 下拉框搜索可选项；
      async loadSearchSelectList() {
        const _ = require('lodash');

        try {
          const res = await squad.getSquadListCoachAll();
          if(res.code) {
            this.$message.error(res.msg);
            return
          }

          // 生成单位可选列表
          const uni_selectYouthList = _.unionBy(res, 'youthUuid')
          this.selectCenterList = uni_selectYouthList.map(item => ({
            label: `${ item.organShortName } - ${ item.youthShortName }`,
            value: item.youthUuid
          }))
        } catch(err) {
          console.error('err', err)
        }
      },

      changeSelectOrg (val) {

        this.changeQuery(true)
      },

      changeQuery (flag) {
        if (flag) this.page = 0
        this.$router.replace({
          path: this.$route.path,
          query: {
            page: 0,
            keyWord: this.selectVal.keyWord,
            youthUuid: this.selectVal.youthUuid,
            organUuid: this.selectVal.organUuid,
            squadDissolve: this.selectVal.squadDissolve,
          }
        })
        this.loadSquadList()
      },

      goDetail(row) {
        const { youthUuid, squadUuid, organUuid } = row;
        this.$router.push({
          path: 'detail',
          query: {
            youthUuid,
            uuid: squadUuid,
            organUuid
          }
        })
      },

    },
  }
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable'
  .list_wrap
    flex 1
    overflow hidden
    .table {
      display flex
      flex-direction column
      flex 1
      width: 100%;
      // margin: 30px 0 0;
      .thead, .tbody {
        border: 1px solid $color_white;
      }
      .thead {
        margin: 0 40px;
        .tr {
          height: 45px;
          display: flex;
        }
      }
      .scrollArea {
        height: 425px;
        padding-bottom 15px
        /*flex 1 */
        /*overflow hidden*/
      }
      .tbodyWrap {
        display block
        // padding: 0 40px;
      }
      .tbody {
        display block
        width 810px
        margin-left auto
        margin-right auto
        max-width: 810px;
        border-top: none;
        border-bottom: none;
        .tr {
          height: 49px;
          display: flex;
          border-bottom: 1px solid $color_white;
        }
      }
      .th, .td {
        height: 100%;
        /*flex: 1 1 auto;*/
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: $font_size_medium;
        border-right: 1px solid $color_white;
      }
      .th:last-child, .td:last-child {
        border-right: none;
      }
      .td {
        p {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          color: $color_white;
        }
      }
      .seq {
        width 7%
      }
      .squadName{
        width 29%
      }
      .organName{
        width 20%
      }
      .centerName{
        width 25%
      }
      .coachName{
        width: 15%;
      }
      /*.leaderName{
        width 15%
      }*/
      .opt{
        width: 13%;
        p{
          width 100%
          text-align center
          .item{
            cursor: pointer;
            user-select: none;
            color $green_color
          }
          .split{
            margin 0 5px
          }
        }
      }
      .squadDissolve{
        color: #f88594 !important
      }
    }
  .demo-ruleForm
    height 475px
  .tip
    margin-top 10px
    color red
    width 100%
    text-align center
    word-break break-word

</style>
